import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "InactiveDashboardsContainer ActContentBlock" }
const _hoisted_2 = { class: "ActDashboardBlockImageWrapper" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "InactiveDashboardContentWrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ActDashboardBlockContent" }
const _hoisted_8 = { class: "ActDashboardTitleSmall" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "ActDashboardSubtitle ActContentBlock" }, " Unlock More Modules ", -1 /* CACHED */)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "ActDashboardText ActContentBlock" }, " View the full range of modules available and expand your organisation's insights. ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
            return _createVNode(_component_LoadingWrapper, {
              classes: ['ActWhiteBlock', 'InactiveDashboardBlock'],
              contentIsActive: false,
              isLoading: _ctx.isLoading
            }, null, 8 /* PROPS */, ["isLoading"])
          }), 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.inactiveDashboards.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.inactiveDashboards, (dashboard) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: dashboard.id,
                    class: "ActWhiteBlock InactiveDashboardBlock"
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("img", {
                        class: "ActDashboardBlockImage",
                        src: _ctx.retrievePreviewUrlForDashboard(dashboard),
                        alt: "Dashboard Preview Image",
                        onClick: ($event: any) => (_ctx.openDashboardPreview(dashboard.id))
                      }, null, 8 /* PROPS */, _hoisted_3),
                      _createElementVNode("i", {
                        class: "lnr-lock1 OverlayLockIcon",
                        onClick: ($event: any) => (_ctx.openDashboardPreview(dashboard.id))
                      }, null, 8 /* PROPS */, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        class: "ActDashboardBlockIcon",
                        src: _ctx.retrieveIconUrlForDashboard(dashboard),
                        alt: "Dashboard Image"
                      }, null, 8 /* PROPS */, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(dashboard.name), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retrieveDescriptionParagraphsForDashboard(dashboard), (paragraph) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: paragraph,
                            class: "ActDashboardSubtitleSmall"
                          }, _toDisplayString(paragraph), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "ChampionButton Small ActDashboardLearnMoreButton",
                      onClick: ($event: any) => (_ctx.openDashboardPreview(dashboard.id))
                    }, " Learn More ", 8 /* PROPS */, _hoisted_9)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, " No more dashboards available. "))
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}